console.log('From background_banner component!!!');